import { defaultColorPalette } from '@/constants/brandingThemes';
import { Link } from '@mui/material';
import { LinkProps, Link as RouterLink } from 'react-router-dom';

export interface SVLinkProps extends LinkProps {
  isWarningLink?: boolean;
}

export default function SVLink({ isWarningLink, ...props }: SVLinkProps) {
  return (
    <Link
      typography="body1"
      fontWeight="bold"
      underline="none"
      component={RouterLink}
      sx={{
        color: isWarningLink ? defaultColorPalette.error : 'primary.main',
      }}
      {...props}
    />
  );
}
